import React ,{useState,useEffect}from "react"
import styles from './FreeTrialMarketingPopupContent.module.css'
import greenCheckImage from '../../Assets/Images/green-check-benefit-table.svg'
import whatappIconImage from '../../Assets/Images/whatapp-icon-benefit-table.svg'
import {fetchDbConstants} from "../../Services/marketingAutomation"
import moment from "moment"
import { connect, useDispatch } from "react-redux";
import { createOrder, pgiAutoLogin } from '../../Services/pgi';
import { url } from '../../Values/constants';
import axiosHandler from "../../Services/axiosHandler";
import CenteredPopUp from '../../Components/CenteredPopUp/CenteredPopUp';
import GSTModal from '../GSTModal/GSTModal';
import AutomaticBillPayementContent from '../AutomaticBillPayementContent/AutomaticBillPayementContent';
import AutomaticBillSetUpContent from '../AutomaticBillSetUpContent/AutomaticBillSetUpContent';
import { pushToGA ,googleAnalytics} from '../../Services/users';

interface FreeTrialMarketingPopupContentProps { user?: any; history?:any;organizationData?: any;}

const FreeTrialMarketingPopupContent: React.FC<FreeTrialMarketingPopupContentProps> = ({ user,history,organizationData}) => {
     

    const [roiDates, setRoiDates] = useState([
        // "Top agents are achieving",
        // "50% higher conversion with",
        // " ",
        // "WhatsApp Business on ReadPro"
    ]);
    const [roiDatesGA, setRoiDatesGA] = useState([]);
    const [roiDay, setRoiDay] = useState<string>("");
    const [token,setToken] = useState<any>()
     const [gst, setGst] = useState<any>();
      const [originalPrice, setOriginalPrice] = useState();
      const [packageId, setPackageId] = useState();
      const [isRecurringPay, setIsRecurringPay] = useState<any>("N");
       const [whatsappRechangePlan, setWhatsappRechangePlan] = useState([
            {
              id:"",
              isTopup: false,
              discountedValue: "",
              originalValue: "",
              discountPercent: "",
              validity: "",
              balance: "",
              packageId:"",
            }
          ]);

     const [finalwhatsappRechangePlan, setFinalWhatsappRechangePlan] = useState([
            {
              id:"",
              isTopup: false,
              discountedValue: "",
              originalValue: "",
              discountPercent: "",
              validity: "",
              balance: "",
              packageId:"",
            }
          ]);
    const [activeFilters, setActiveFilters] = useState<string[]>(["Recharge"]);
    const [defaultPackage, setDefaultPackage] = useState<any>();
    const [offerPrice, setOfferPrice] = useState();
    const [balance, setBalance] = useState();
    const [val, setVal] = useState();
    const [discountVal, setdiscountVal] = useState();
    const [openTryAutoPayModal, setOpenTryAutoPayModal] = useState<boolean>(false);
     const [openGstModal, setOpenGstModal] = useState<boolean>(false);
       const [openSetUpAutoPayModal, setOpenSetUpAutoPayModal] = useState<boolean>(false);
       const [recr, setRecr] = useState<any>();
    
       useEffect(() => {
        const fetchData = async () => {
            try {
                const data: any = await fetchDbConstants(["roiDates"]);
                if (data && data[0]?.data?.[0]) {
                    const currentDay = moment().format("dddd"); 
                    
                    setRoiDay(currentDay);
                    
                    const roiDatesValue = data[0].data[0][currentDay];
                    if (roiDatesValue !== undefined) {
                        setRoiDates(roiDatesValue);
                        setRoiDatesGA(roiDatesValue)
                    }
                }
            } catch (error: any) {
                // console.log("Error fetching ROI dates:", error.message);
            }
        };
    
        fetchData();
    }, []);
    
    // console.log("roiDates", roiDates);
    // console.log("roiDay", roiDay);

    const taginsert = async (tagg:any,packId:any,amt:any) => {
      const apiUrl = url+"/miscellaneous/tagUpdate";
      const payload = {
        free_trial:tagg,
        actual_packId:packId,
        actual_amount:amt,
        orgId:organizationData.organization_id,
        oid:organizationData.oid,
        screen:"FreeTrialMarketingPopupContent",
      };
    // console.log("sendMail--payload",payload)
      try {
        const response = await axiosHandler.post(apiUrl, payload);
      //  console.log("miscellaneous done response",response)
       return response.data.data
      } catch (error:any) {
        // Handle errors
        // console.error("Error fetching responses:", error.response || error);
        throw error;
      }
    };


    useEffect(()=>{
        
        // console.log("buyPrice",buyPrice)
        // {token &&
        //   // window.open(token)
          
        //   createOrder(gst,user.user_super_oid,originalPrice,originalPrice,packageId,token,isRecurringPay,"ft");
        // }
        const fetchData = async () => {
          if((organizationData.WhatsAppTrialPack===true ) && isRecurringPay==="N"){
              // console.log("isRecurringPay===N")
              const tag = await taginsert("ft",packageId,originalPrice)
              // console.log("tag tag",tag)
                  {token && createOrder(gst,user.user_super_oid,originalPrice,originalPrice,packageId,token,isRecurringPay,tag._id)}
                }else if((organizationData.WhatsAppTrialPack===true ) && isRecurringPay==="Y"){
                  const tag = await taginsert("ft",packageId,originalPrice)
          // console.log("tag tag",tag)
                  {token && createOrder(gst,user.user_super_oid,"1",originalPrice,"310973",token,isRecurringPay,tag._id)}
                }else{
                  // console.log("else")
  
                  {token && createOrder(gst,user.user_super_oid,originalPrice,originalPrice,packageId,token,isRecurringPay)}
                }}
                fetchData();  
       },[token])

    const filterData = (data: any[], activeFilters: string[]) => {
        if (activeFilters.includes("Topup") && activeFilters.includes("Recharge")) {
          // Return all data if both filters are active
          // console.log(data);
          return data;
        }
      
        if (activeFilters.includes("Topup")) {
          // Filter data where isTopup is true
          const filteredData = data.filter(item => item.isTopup === true);
          // console.log(filteredData);
          return filteredData;
        }
      
        // Otherwise, filter data where isTopup is false
        const filteredData = data.filter(item => item.isTopup === false);
        // console.log(filteredData);
        return filteredData;
      };


      useEffect(()=>{
          readProductList()
         },[user])

    const readProductList = async () => {
        // const apiUrl = url+"/pgi/readProductList";
    
        const apiUrl =url+"/pgi/readProductList"
    
        const payload = {
              soid: user.user_super_oid,
        };
      
        try {
          // console.log(" payload:", payload);
      
          const response = await axiosHandler.post(apiUrl, payload);
    
          // console.log("response",response.data.responsePayloadData.pgiRefId)
          const data = response.data;
        //   console.log("data.data",data.data)
          setWhatsappRechangePlan(data.data)
          const mainData = data.data.map((plan:any, index:any) => {
            const isPopular = index === 0; // Example logic for isPopular
            const isBestValue = index === 1; // Example logic for isBestValue
            const discountedValue = plan.discountedValue
              // plan.discountPercent === "100"
              //   ? plan.discountedValue
              //   : (plan.originalValue * (100 - plan.discountPercent)) / 100;
          
            return {
              id: (index + 1).toString(),
              isPopular,
              isBestValue,
              isTopup: plan.isTopup,
              discountedValue: discountedValue.toString(),
              originalValue: plan.originalValue,
              discountPercent: plan.discountPercent,
              validity: plan.validity,
              balance: plan.balance,
              packageId: plan.packageId,
            };
          });
          setFinalWhatsappRechangePlan(filterData(mainData,activeFilters))
    
        } catch (error:any) {
          // Handle errors
        //   console.error("Error fetching responses:", error.response || error);
          throw error;
        }
      };

      // useEffect(()=>{
      //   const minPackage = finalwhatsappRechangePlan.reduce((prev, current) => {
      //       return parseFloat(prev.discountedValue || "0") <= parseFloat(current.discountedValue || "0")
      //           ? prev
      //           : current;
      //   });
      //   setDefaultPackage(minPackage)
      //    },[finalwhatsappRechangePlan])
      useEffect(()=>{
              const filteredPlans = finalwhatsappRechangePlan.filter((plan:any) => plan.packageId !== "310973");
      // console.log("filteredPlans",filteredPlans)
          if (filteredPlans.length === 0) {
              setDefaultPackage(null); // No valid packages left
              return;
          }
              const minPackage = filteredPlans.reduce((prev, current) => {
                  return parseFloat(prev.discountedValue || "0") <= parseFloat(current.discountedValue || "0")
                      ? prev
                      : current;
              });
              // console.log("minPackage",minPackage)
              setDefaultPackage(minPackage)
               },[finalwhatsappRechangePlan])

        const onClickHandler = (originalPrice:any,offerPrice:any,packageId:any,validity:any,balance:any,isRec:any) => {
            // console.log("isRecisRec",isRec)
      setIsRecurringPay(isRec)
          const msgData = {
            oid: user.user_super_oid,
            offerPrice: (offerPrice && offerPrice!=="0")?offerPrice:originalPrice,
            originalPrice: originalPrice,
            packageId:packageId,
            validity:validity,
            balance:balance,
            userName:`${user.user_first_name} ${user.user_last_name}`,
            usereMail:user.user_email
          }
          localStorage.setItem("msgData", JSON.stringify(msgData));
          pgiAutoLogin(user.user_oid,(data: any) => setToken(data))
          // setIframeCreated(true)
          document.body.classList.add("no-overflow");
        };

        const setDataHandler = (originalPrice:any,offerPrice:any,packageId:any,validity:any,balance:any,dis:any) => {
    
            setPackageId(packageId)
            setOfferPrice((offerPrice && offerPrice!=="0")?offerPrice:originalPrice)
            setOriginalPrice(originalPrice)
            setBalance(balance)
            setVal(validity)
            setdiscountVal(dis)
            setOpenTryAutoPayModal(true)
          };

          const [isGACalled, setIsGACalled] = useState<any>(false);
   
             useEffect(() => {
                    if (!isGACalled && Array.isArray(roiDatesGA) && roiDatesGA.length > 1) {
                      // console.log("roiDatesGA", roiDatesGA);
                  
                      if (user?.uid && user?.profile) {
                        setIsGACalled(true);
                        googleAnalytics(`freeTrialMarketingPopup(${roiDatesGA[0]}${roiDatesGA[1]})`, user);
                      }
                    }
                  }, [user, roiDatesGA, isGACalled]);
  

     
    
    
  return (
    <>
      {
        (roiDates && roiDates.length > 0) && (
          <div className={styles.FreeTrialMarketingContent}>
            <div className={styles.FreeTrialMarketingWrapper}>
              <div className={styles.FreeTrialMarketingSubtxt}>{roiDates[0]} <span className={styles.splText}>{roiDates[1]}</span></div>
              <div className={styles.FreeTrialMarketingTitle}>{roiDates[2]}<span className={styles.textNormal}>With</span><span className={styles.WhatappIcon}><img src={whatappIconImage} /></span>{roiDates[3]}</div>
              <div className={styles.BenefitWrapper}>
                <span className={styles.BenefitWrapperTag}>Here's how?</span>
                <div className={styles.BenefitTable}>
                  <div className={styles.BenefitHeader}>
                    <div className={styles.BenefitRow}>
                      <div className={styles.BenefitCol}>Benefits</div>
                      <div className={`${styles.BenefitCol} ${styles["wrpro"]}`}>
                        <div className={styles.text}>With ReadPro</div>
                        <div className={styles.textSmall}>WhatsApp Business</div>
                      </div>
                      <div className={styles.BenefitCol}>
                        <div className={styles.text}>Without ReadPro</div>
                        <div className={styles.textSmall}>WhatsApp Business</div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.BenefitBody}>
                    <div className={styles.BenefitRow}>
                      <div className={styles.BenefitCol}><span className={styles.textSemibold}>Higher Open Rate</span> of messages</div>
                      <div className={styles.BenefitCol}><img className={styles.checkSign} src={greenCheckImage} /></div>
                      <div className={styles.BenefitCol}><span className={styles.crossSign}></span></div>
                    </div>
                    <div className={styles.BenefitRow}>
                      <div className={styles.BenefitCol}><span className={styles.textSemibold}>Instant response from serious buyers</span></div>
                      <div className={styles.BenefitCol}><img className={styles.checkSign} src={greenCheckImage} /></div>
                      <div className={styles.BenefitCol}><span className={styles.crossSign}></span></div>
                    </div>
                    <div className={styles.BenefitRow}>
                      <div className={styles.BenefitCol}><span className={styles.textSemibold}>Verified business account with blue tick</span>
                        <div className={styles.Condition}>*Subject to Meta Approval</div>
                      </div>
                      <div className={styles.BenefitCol}><img className={styles.checkSign} src={greenCheckImage} /></div>
                      <div className={styles.BenefitCol}><span className={styles.crossSign}></span></div>
                    </div>
                    <div className={styles.BenefitRow}>
                      <div className={styles.BenefitCol}><span className={styles.textSemibold}>100% data security</span> - No third party sharing</div>
                      <div className={styles.BenefitCol}><img className={styles.checkSign} src={greenCheckImage} /></div>
                      <div className={styles.BenefitCol}><span className={styles.crossSign}></span></div>
                    </div>
                    <div className={styles.BenefitRow}>
                      <div className={styles.BenefitCol}><span className={styles.textSemibold}>Ready-to-use message templates</span></div>
                      <div className={styles.BenefitCol}><img className={styles.checkSign} src={greenCheckImage} /></div>
                      <div className={styles.BenefitCol}><span className={styles.crossSign}></span></div>
                    </div>
                  </div>
                </div>
                <div className={styles.BenefitActions}>
                  <div className={styles.FreeTrialMarketingOffer}>Get <span className={styles.TextRed}><span className={styles.Rupees}>&#8377;</span>500</span> <span className={styles.textMedium}><span className={styles.PartyIcon}></span>Welcome Bonus</span></div>
                  <span className={styles.BenefitCtaFilled} onClick={() => {
                    if(Array.isArray(roiDatesGA) && roiDatesGA.length > 1){
                      pushToGA(
                        "event_tracking",
                        "read pro",
                        "read pro",
                        `whatsapp freeTrialMarketingPopup(${roiDatesGA[0]}${roiDatesGA[1]}) | cta :Start Trial Now click`,
                        user,
                        // eventLabel ? eventLabel : ""
                      )
                    }
                    // Find the package with the minimum discounted value
                    // const minPackage = finalwhatsappRechangePlan.reduce((prev, current) => {
                    //     return parseFloat(prev.discountedValue || "0") <= parseFloat(current.discountedValue || "0")
                    //         ? prev
                    //         : current;
                    // });

                    // Call setDataHandler with the details of the minimum package
                    setDataHandler(
                      defaultPackage.originalValue,
                      defaultPackage.discountedValue,
                      defaultPackage.packageId,
                      defaultPackage.validity,
                      defaultPackage.balance,
                      defaultPackage.discountPercent
                    );
                  }}>Start FREE Trial</span>
                </div>
                <div className={styles.BenefitDivider}></div>
                <div className={styles.BenefitPostFree}>Post Free trail, plan subscription starts from <span className={styles.textSemibold}>Rs.{defaultPackage?.discountedValue !== "0" ? defaultPackage?.discountedValue : defaultPackage?.originalValue}/month</span> Cancel anytime you like!</div>
              </div>
            </div>
            {
              openGstModal &&
              <CenteredPopUp
                setModal={setOpenGstModal}
                children={
                  <GSTModal
                    setGst={setGst}
                    PayModal={() => onClickHandler(originalPrice, offerPrice, packageId, val, balance, recr)} />
                }
                modiferClass={styles.gstPopup}
                closeIcon={true}
              />
            }
            {
              openTryAutoPayModal &&
              <CenteredPopUp
                setModal={setOpenTryAutoPayModal}
                children={
                  <AutomaticBillPayementContent
                    setOpenSetUpAutoPayModal={setOpenSetUpAutoPayModal}
                    PayModal={setOpenGstModal}
                    setRecr={setRecr}
                    originalPrice={originalPrice}
                    offerPrice={offerPrice}
                    packageId={packageId}
                    setOpenTryAutoPayModal={setOpenTryAutoPayModal}
                  />
                }
                modiferClass={styles.Tabp}
                closeIcon={true}
              />
            }
            {
              openSetUpAutoPayModal &&
              <CenteredPopUp
                setModal={setOpenSetUpAutoPayModal}
                children={
                  <AutomaticBillSetUpContent
                    setOpenSetUpAutoPayModal={setOpenSetUpAutoPayModal}
                    setOpenRechargeProcessing={setOpenGstModal}
                    originalPrice={originalPrice}
                    offerPrice={offerPrice}
                    packageId={packageId}
                    balance={balance}
                    val={val}
                    discountVal={discountVal}
                    organizationData={organizationData}
                  />
                }
                modiferClass={styles.Tabp}
                closeIcon={true}
              />
            }
          </div>
        )
      }
    </>
  )
}

const mapStateToProps = (state: any) => {
    return {
      user: state.user.data,
      organizationData: state.organization.organizationData,
    };
  };


export default connect(mapStateToProps)(FreeTrialMarketingPopupContent)